import { Routes } from '@angular/router';

// component nicht über index laden, ergibt runtime fehler
import { ClientInventoryComponent } from './client-inventory.component';
import { AuthGuard } from '../services/index';

export const clientInventoryRoutes: Routes = [
    { path: 'clientInventory', component: ClientInventoryComponent, canActivate: [AuthGuard]  }
];


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/client-inventory/client-inventory.routes.ts